import React, { useState } from 'react';
import Aptable from '../../admincomponents/AddedProductsTable/Aptable';
import { FiMenu, FiX } from 'react-icons/fi';
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';
import './AddedProducts.css';

const AddedProducts = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className='products-admin-container'>
      {/* Mobile Navigation Toggle */}
      <button 
        className="products-mobile-nav-toggle"
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Imported Vertical Navigation */}
      <AdmVertNav 
        mobileNavOpen={mobileNavOpen} 
        closeMobileNav={() => setMobileNavOpen(false)} 
      />

      {/* Main Content Area */}
      <div className="products-admin-main-content">
        <div className="products-content-header">
          <h1>Manage Products</h1>
          <div className="products-breadcrumb">Admin / Products</div>
        </div>
        <div className="products-content-body">
          <Aptable />
        </div>
      </div>
    </div>
  );
};

export default AddedProducts;